<template>
    <div class="progress_item">
        <slot name="img"></slot>
        <div class="course_news">
            <div class="course_title">
                <slot name="title"></slot>
            </div>
            <div class="course_small_title">
                <slot name="small_title"></slot>
            </div>
        </div>
        <div class="course_progress">
            <el-progress
                :percentage="learnNum"
                :color="isFinish ? '#ff8e09 ' : '#2bbcff'"
                :show-text="false"
            ></el-progress>
            <div class="course_progress_num" :class="{ itemFinish: isFinish }">
                已学习<span v-if="isFinish">100%</span
                ><span v-else>{{ learnNum }}%</span>
            </div>
        </div>
        <div class="progress_btn">
            <p class="continue" v-if="!isFinish && isLearn=='true'" @click="continueLearning">
                继续学习
            </p>
            <p  v-if="!isFinish && isLearn=='false'">
                继续学习
            </p>
            <p class="over" v-if="isFinish">已完成</p>
        </div>
    </div>
</template>
<script>
import { PcCookie, Key } from "@/utils/cookie";
import { checkGxkSignup } from "api/train"
export default {
    name: "StudyItem",
    props: {
        //培训班id
        trainId: {
            type: String,
            default: "",
        },
        //课程id
        courseId: {
            type: String,
            default: "",
        },
        //是否学习完
        isFinish: {
            type: Boolean,
            default: false,
        },
        //完成状态
        status: {
            type: String,
            default: "",
        },
        //播放位置
        playNum: {
            type: Number,
            default: 0,
        },
        //总播放时长
        totalNum: {
            type: Number,
            default: 0,
        },
        //课程章节id
        id: {
            type: String,
            default: "",
        },
        //是否能学习
        isLearn:{
            type: String,
            default: "",
        },
        //校验学员学习资格
        categoryInfoId:{
            type: String,
            default: "",
        },
    },
    computed: {
        learnNum() {
            var num = 0;
            if (this.status === "1") {
                num = 100;
            } else {
                num = Math.round((this.playNum / this.totalNum) * 100);
            }
            return num;
        },
    },
    methods: {
        async continueLearning() {
            if(this.classroomStatus == '0'){
                this.$message({
                    message: '该培训班已结班，不能进行学习了！',
                    type: 'warning'
                });
            }else{
                const sessionId = PcCookie.get(Key.jsessIdKey);
                const res = await  checkGxkSignup(sessionId,this.categoryInfoId)
                if(res.errorCode == '5000'){
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    });
                }else{
                    this.$router.push({
                        path: "/pcViews/learn/course",
                        query: {
                            courseId: this.courseId,
                            trainId: this.trainId,
                            id: this.id,
                        },
                    });
                }
            }
        },
    },
};
</script>
<style>
.course_progress .el-progress {
    width: calc(100% - 88px);
}
</style>
<style scoprd>
.over {
    color: #ff8e09;
}
.continue {
    color: #2bbcff;
    text-decoration: underline;
    cursor: pointer;
}
.progress_btn {
    margin: 0 12px;
    text-align: center;
    flex: 1;
    font-size: 14px;
}
.course_progress_num.itemFinish span {
    color: #ff8e09;
}
.course_progress_num span {
    margin-left: 6px;
    color: #2bbcff;
}
.course_progress_num {
    font-size: 14px;
    color: #818181;
}
.course_progress {
    width: 418px;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.course_small_title {
    width: 100%;
    height: 22px;
    line-height: 22px;
    font-size: 14px;
    color: #3b3b3b;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.course_title {
    width: 100%;
    height: 26px;
    line-height: 26px;
    font-size: 16px;
    color: #000;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.course_news {
    width: 246px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.userImg {
    width: 118px;
    height: 66px;
    margin-right: 14px;
}
.progress_item {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 10px;
    margin: 12px 0;
    height: 86px;
    border: solid 1px #e6e6e6;
}
</style>
